import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '@/lib/auth';
import type { UserRole } from '@/graphql/generated';
import { Spinner } from '@/components/ui/misc';
import { EmptyState } from '@/components/ui/states';
import { ShieldX } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router';

/** Ruta que exige sesión. Recuerda el destino para volver tras entrar. */
export function RequireAuth() {
  const { user, isBootstrapping, mustChangePassword } = useAuth();
  const location = useLocation();

  if (isBootstrapping) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-canvas">
        <Spinner label="Cargando…" />
      </div>
    );
  }

  if (!user || mustChangePassword) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}

/** Ruta restringida por rol. */
export function RequireRole({ roles }: { roles: readonly UserRole[] }) {
  const { user } = useAuth();

  if (user && !roles.includes(user.role)) {
    return (
      <div className="page">
        <EmptyState
          icon={<ShieldX aria-hidden="true" />}
          title="No tienes acceso a esta sección"
          description="Tu rol no incluye estos permisos. Si crees que es un error, escribe al administrador."
          action={
            <Button variant="secondary" asChild>
              <Link to="/">Volver al tablero</Link>
            </Button>
          }
        />
      </div>
    );
  }

  return <Outlet />;
}
